import { z } from 'zod';

import { notificationSchema } from './Notification';

export const notificationsListSchema = z
  .object({
    items: z.array(notificationSchema),
    unread_count: z.number(),
    total: z.number(),
  })
  .transform((raw) => ({
    items: raw.items,
    unreadCount: raw.unread_count,
    total: raw.total,
  }));

export type NotificationsListEntityApi = z.input<typeof notificationsListSchema>;

export type NotificationsListEntity = z.infer<typeof notificationsListSchema>;
